import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
  schema?: Record<string, unknown>;
}

export function Helmet({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  twitterCard = 'summary_large_image',
  schema,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', description);

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords && keywords) metaKeywords.setAttribute('content', keywords);
    else if (metaKeywords) metaKeywords.remove();

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && canonicalUrl) canonical.setAttribute('href', canonicalUrl);
    else if (canonical) canonical.remove();

    const ogTitleMeta = document.querySelector('meta[property="og:title"]');
    if (ogTitleMeta && ogTitle) ogTitleMeta.setAttribute('content', ogTitle);
    const ogDescMeta = document.querySelector('meta[property="og:description"]');
    if (ogDescMeta && ogDescription) ogDescMeta.setAttribute('content', ogDescription);
    const ogImageMeta = document.querySelector('meta[property="og:image"]');
    if (ogImageMeta && ogImage) ogImageMeta.setAttribute('content', ogImage);
    const ogTypeMeta = document.querySelector('meta[property="og:type"]');
    if (ogTypeMeta) ogTypeMeta.setAttribute('content', ogType);

    const twCardMeta = document.querySelector('meta[name="twitter:card"]');
    if (twCardMeta) twCardMeta.setAttribute('content', twitterCard);
    const twTitleMeta = document.querySelector('meta[name="twitter:title"]');
    if (twTitleMeta && ogTitle) twTitleMeta.setAttribute('content', ogTitle);
    const twDescMeta = document.querySelector('meta[name="twitter:description"]');
    if (twDescMeta && ogDescription) twDescMeta.setAttribute('content', ogDescription);
    const twImageMeta = document.querySelector('meta[name="twitter:image"]');
    if (twImageMeta && ogImage) twImageMeta.setAttribute('content', ogImage);

    if (schema) {
      let scriptEl = document.querySelector('script[type="application/ld+json"][data-dynamic]');
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.setAttribute('type', 'application/ld+json');
        scriptEl.setAttribute('data-dynamic', 'true');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogImage, ogType, twitterCard, schema]);

  return null;
}